// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon-UnYS9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/buttons/icon-button/icon-button.less
 ** module id = 164
 ** module chunks = 0
 **/